import { render, staticRenderFns } from "./MvpView.vue?vue&type=template&id=28f46088&scoped=true&"
import script from "./MvpView.vue?vue&type=script&lang=js&"
export * from "./MvpView.vue?vue&type=script&lang=js&"
import style0 from "./MvpView.vue?vue&type=style&index=0&id=28f46088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f46088",
  null
  
)

export default component.exports